export const formatVideoUrl = (
	url: string,
	isYoutubeVideo: boolean
): string => {
	if (isYoutubeVideo) {
		const lastSlashIndex = url.lastIndexOf("/");
		const embedUrl =
			url.substring(0, lastSlashIndex) +
			"/embed/" +
			url.substring(lastSlashIndex + 1);
		return embedUrl.replace("watch?v=", "");
	}
	const vimeoIndex = url.indexOf("vimeo");
	const beforeVimeo = url.substring(0, vimeoIndex);
	const vimeoUrl = url.substring(vimeoIndex).lastIndexOf("/");
	const id = url.substring(vimeoIndex).substring(vimeoUrl);
	const formattedUrl = `${`${beforeVimeo}player.${url.substring(
		vimeoIndex
	)}`.replace(id, "")}/video${id}`;

	return formattedUrl;
};

export const formatUrl = (url: string): string => {
	if (url.indexOf("http") === -1 || url.indexOf("https") === -1) {
		const urlWithProtocol = `https://${url}`;
		const parsedUrl = new URL(urlWithProtocol);
		return parsedUrl.href;
	}
	return url;
};

export const validateUrl = (url: string): boolean => {
	const urlRegex =
		/^(?:https?:\/\/)?(?:www\.)?[\w-]+\.[\w]{2,20}(?:\.[\w]{2,20})?(?:\/[\w-]*)*\/?$/i;

	return urlRegex.test(url);
};
